import axios from 'axios';
import Breadcrumb from 'components/Breadcrumb';
import Loading from 'components/Loading';
import PdfFile from 'components/PDF';
import { priceFormat } from 'helper/common';
import { getDate } from 'helper/date';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { Maybe } from 'models/types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import { FlightResultInterface } from './result.interface';
import * as S from './result.styles';

const FreeTicketResultPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [ticketData, setTicketData] = useState<Maybe<FlightResultInterface>>(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(urls.singleFreeTicket(params?.id || ''))
      .then((res) => {
        setTicketData(res.data.response);
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const ptcBaceFar = () => {
    const ptcfareBreakdowns = ticketData?.bookData.priceInfo.ptcfareBreakdowns.ptcfareBreakdown
      .map((items) =>
        items.passengerFare.reduce((acc, curr) => {
          return acc + Number(curr.baseFare.amount);
        }, 0)
      )
      .reduce((ac, crr) => {
        return ac + crr;
      }, 0);
    return ptcfareBreakdowns;
  };

  const ptcTotalFar = () => {
    const ptcfareBreakdowns = ticketData?.bookData.priceInfo.ptcfareBreakdowns.ptcfareBreakdown
      .map((items) =>
        items.passengerFare.reduce((acc, curr) => {
          return acc + Number(curr.totalFare.amount);
        }, 0)
      )
      .reduce((ac, crr) => {
        return ac + crr;
      }, 0);
    return ptcfareBreakdowns;
  };

  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.index().name}`),
      url: Paths.Services.index().route,
      active: false,
    },
    {
      title: t(`pageTitles.${Paths.Services.awardTicketResult().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  return (
    <WithSidebar>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Breadcrumb links={breadcrumbLinks} title={t('pages.services.flight.pages.result.title')} />
          <S.Wrapper>
            {ticketData?.transaction?.status === 'ok' && (
              <div>
                <PdfFile ticketData={ticketData} />{' '}
              </div>
            )}

            {ticketData?.transaction ? (
              <S.TransactionSatatus $color={ticketData.transaction.status}>
                {ticketData.transaction.status === 'ok' ? (
                  <h1>{t('pages.services.flight.pages.result.sections.ok.title')}</h1>
                ) : (
                  <h1>{t('pages.services.flight.pages.result.sections.notOk.title')}</h1>
                )}
                <p>
                  {t('pages.services.flight.pages.result.sections.ok.systemTraceNo')}
                  {': '}
                  {ticketData.transaction.systemTraceNo ? ticketData.transaction.systemTraceNo : '_'}
                </p>
                <p>
                  {t('pages.services.flight.pages.result.sections.ok.amount')} {': '}
                  {ticketData.transaction.amount ? priceFormat(ticketData.transaction.amount) : '_'} IRR
                </p>
              </S.TransactionSatatus>
            ) : (
              ''
            )}
            {ticketData?.bookData && (
              <>
                <div>
                  {/* <Button width={100}>{t('pages.signup.sections.form.attachBtn')}</Button> */}
                  <div id="content">
                    <S.TitleCard>
                      {t('pages.services.flight.pages.result.sections.ok.passengers.title.label')}
                    </S.TitleCard>
                    <S.CardResult>
                      <S.DetailsWrapper>
                        <S.Details>
                          <S.parentItems>
                            <S.SmallText>
                              {' '}
                              {t('pages.services.flight.pages.result.sections.ok.passengers.name.label')}
                            </S.SmallText>
                            <S.FlightNumber>{`${ticketData?.bookData?.contactPerson.personName.givenName[0]} ${ticketData?.bookData?.contactPerson.personName.surname}`}</S.FlightNumber>
                          </S.parentItems>

                          {ticketData?.bookData?.travelerInfo.airTraveler.map((traveler) => {
                            return (
                              <>
                                <S.parentItems>
                                  <S.SmallText>
                                    {t(
                                      'pages.services.flight.pages.result.sections.ok.passengers.dateOfBirth.label'
                                    )}{' '}
                                  </S.SmallText>
                                  <S.FlightNumber>{getDate(traveler.birthDate)}</S.FlightNumber>
                                </S.parentItems>
                                <S.parentItems>
                                  <S.SmallText>
                                    {traveler.document[0].docType === '2'
                                      ? ` ${t(
                                        'pages.services.flight.pages.result.sections.ok.passengers.passportNumber.label'
                                      )}`
                                      : ` ${t(
                                        'pages.services.flight.pages.result.sections.ok.passengers.nationalCode.label'
                                      )}`}{' '}
                                  </S.SmallText>
                                  <S.FlightNumber>{traveler.document[0].docID}</S.FlightNumber>
                                </S.parentItems>
                              </>
                            );
                          })}
                        </S.Details>
                      </S.DetailsWrapper>
                    </S.CardResult>

                    <S.TitleCard>
                      {t('pages.services.flight.pages.result.sections.ok.flightInfo.title.label')}{' '}
                      {`PNR : ${ticketData.awardticket.PNR}`}{' '}
                    </S.TitleCard>
                    {ticketData?.bookData?.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.map(
                      (traveler) => {
                        return (
                          <S.CardResult>
                            <S.DetailsWrapper>
                              <S.Details>
                                <S.parentItems>
                                  <S.SmallText>
                                    <img src={`/passenger/images/static/logo-blue-iranair.png`} width={'50px'} />
                                  </S.SmallText>
                                  <S.FlightNumber>
                                    {t('pages.services.flight.pages.result.sections.ok.flightInfo.flightNum.label')}{' '}
                                    {traveler.flightNumber}
                                  </S.FlightNumber>
                                </S.parentItems>
                                <S.parentItems>
                                  <S.SmallText>
                                    {' '}
                                    {t('pages.services.flight.pages.result.sections.ok.flightInfo.origin.label')}
                                  </S.SmallText>
                                  <S.ContainerFlight>
                                    <S.FlightNumber>{getDate(traveler.departureDateTime)}</S.FlightNumber>
                                    <S.FlightNumber>{traveler.departureAirport.locationCode}</S.FlightNumber>
                                    <S.FlightNumber>{traveler.departureAirport.locationName}</S.FlightNumber>
                                  </S.ContainerFlight>
                                </S.parentItems>
                                <S.parentItems>
                                  <S.SmallText>
                                    {t('pages.services.flight.pages.result.sections.ok.flightInfo.destination.label')}{' '}
                                  </S.SmallText>
                                  <S.ContainerFlight>
                                    <S.FlightNumber>{getDate(traveler.arrivalDateTime)}</S.FlightNumber>
                                    <S.FlightNumber>{traveler.arrivalAirport.locationCode}</S.FlightNumber>
                                    <S.FlightNumber>{traveler.arrivalAirport.locationName}</S.FlightNumber>
                                  </S.ContainerFlight>
                                </S.parentItems>
                                <S.parentItems>
                                  <S.SmallText>
                                    {t('pages.services.flight.pages.result.sections.ok.flightInfo.flightClass.label')}{' '}
                                  </S.SmallText>
                                  <S.FlightNumber>
                                    {traveler.resBookDesigCode === 'Z1' ? 'Business' : 'economy'}
                                  </S.FlightNumber>
                                </S.parentItems>
                              </S.Details>
                            </S.DetailsWrapper>
                          </S.CardResult>
                        );
                      }
                    )}

                    <S.TitleCard>
                      {t('pages.services.flight.pages.result.sections.ok.priceInfo.title.label')}{' '}
                    </S.TitleCard>

                    <S.CardResult>
                      <S.DetailsWrapper>
                        <S.Details>
                          <S.parentItems>
                            <S.SmallText>
                              {t('pages.services.flight.pages.result.sections.ok.priceInfo.basePrice.label')}{' '}
                            </S.SmallText>
                            <S.FlightNumber>{priceFormat(Number(ptcBaceFar()))} IRR</S.FlightNumber>
                          </S.parentItems>
                          <S.parentItems>
                            <S.SmallText>
                              {t('pages.services.flight.pages.result.sections.ok.priceInfo.tax.label')}
                            </S.SmallText>
                            <S.FlightNumber>
                              {priceFormat(Number(ptcTotalFar()) - Number(ptcBaceFar()))} IRR
                            </S.FlightNumber>
                          </S.parentItems>
                          <S.parentItems>
                            <S.SmallText>
                              {t('pages.services.flight.pages.result.sections.ok.priceInfo.totalPrice.label')}{' '}
                            </S.SmallText>
                            <S.FlightNumber>{priceFormat(Number(ptcTotalFar()))} IRR</S.FlightNumber>
                          </S.parentItems>
                        </S.Details>
                      </S.DetailsWrapper>
                    </S.CardResult>
                  </div>
                </div>
              </>
            )}
          </S.Wrapper>
        </>
      )}
    </WithSidebar>
  );
};

export default FreeTicketResultPage;
